import FJClose from '../../../common/components/FJClose/FJClose';
import styles from './FJModalClose.module.less';
import PropTypes from 'prop-types';
function FJModalClose(props) {
    let { onClick } = props;
    return (
        <div className={styles.close} onClick={onClick}>
            <FJClose />
        </div>
    );
}
FJModalClose.propTypes = {
    onClick: PropTypes.func,
};
export default FJModalClose;
